import * as L from 'leaflet';

// cria o mapa do OpenStreetMaps
export const createMapOSM = (osmUrl = 'http://{s}.tile.osm.org/{z}/{x}/{y}.png', attr) => {
	const osmAttrib = attr ? attr : 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors';
	return new L.TileLayer(osmUrl, { attribution: osmAttrib });
}

export const createLayer = (wms_url, layer, cql_filter, styles, env) => {

    let options = {
      layers: layer,
      format: 'image/png', 
      EPSG: '4326',
      tiled: true,
      //tileSize: L.point(3000,3000),
      transparent: true, 
      attribution: '',
      opacity: 1
    }
  
    // cria os seguintes atributos apenas se forem especificados nos parâmetros
    if (cql_filter) {
      options.cql_filter = cql_filter;
    }
    options.styles = styles ? styles : '';
    options.env = env ? env : undefined;
  
    return new L.tileLayer.wms(wms_url, options);
  
  }
